import { ThemeEvents, CartUpdatedEvent } from '@theme/events';

// Un seul échantillon offert par commande : les unités gratuites en trop
// sont remplacées par la version payante de la même variante.
const configEl = document.getElementById('echantillon-guard-config');
const config = configEl ? JSON.parse(configEl.textContent) : null;
const SOURCE = 'echantillon-guard';
let busy = false;

async function postJSON(url, body) {
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  });
  return res.json();
}

function plan(cart) {
  let freeLeft = 1;
  const updates = {};
  const adds = [];

  // Parcours dans l'ordre de priorité des règles, puis dans l'ordre du panier.
  config.rules.forEach((rule) => {
    cart.items
      .filter((item) => item.handle === rule.handle && item.original_price === 0)
      .forEach((item) => {
        const keep = Math.min(item.quantity, freeLeft);
        freeLeft -= keep;
        const extra = item.quantity - keep;
        if (!extra) return;

        updates[item.key] = keep;
        const paidId = rule.paid[item.variant_title] || Object.values(rule.paid)[0];
        if (paidId) adds.push({ id: paidId, quantity: extra });
      });
  });

  return { updates, adds };
}

async function enforce() {
  if (!config || busy) return;
  busy = true;
  try {
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    const { updates, adds } = plan(cart);
    if (!Object.keys(updates).length) return;

    if (adds.length) await postJSON('/cart/add.js', { items: adds });

    const drawer = document.querySelector('cart-drawer');
    const sectionId = drawer?.dataset.sectionId;
    const updated = await postJSON('/cart/update.js', {
      updates,
      ...(sectionId ? { sections: sectionId, sections_url: window.location.pathname } : {}),
    });

    document.dispatchEvent(new CustomEvent('toast:open', { detail: { type: 'info', message: config.message } }));

    if (Theme?.template?.name === 'cart') {
      window.location.reload();
      return;
    }

    document.dispatchEvent(
      new CartUpdatedEvent(updated, { source: SOURCE, sections: updated.sections, itemCount: updated.item_count }),
    );
  } catch (e) {
    console.error(e);
  } finally {
    busy = false;
  }
}

document.addEventListener(ThemeEvents.cartUpdated, (event) => {
  if (event.detail?.data?.source === SOURCE) return;
  enforce();
});

// Couvre la page /cart (rechargée après chaque modification) et les ajouts faits par des apps.
enforce();
